export default __webpack_public_path__ + "static/media/div-breadcrumb.2a3c6fb7.svg";